<template>
  <div class="partner-logos">
    <div v-for="(logo, index) in logos" :key="index" class="logo-item">
      <img :src="logo.url" :alt="`Partner ${index + 1}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerLogos",
  data() {
    return {
      logos: [
        { url: require("../assets/img/h1.png") },
        { url: require("../assets/img/h2.png") },
        { url: require("../assets/img/h3.png") },
        { url: require("../assets/img/h4.png") },
        { url: require("../assets/img/h5.png") },
        { url: require("../assets/img/h6.png") },
      ],
    };
  },
};
</script>

<style scoped>
.partner-logos {
  float: left;
  width: 100%;
  background: #f6f6f6;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1%; /* 调整每个 Logo 之间的间距 */
}

.logo-item {
  width: 15%; /* 每个 Logo 的宽度为 16% */
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 10px; /* 调整 Logo 之间的垂直间距 */
}

.logo-item img {
  width: 100%;
  height: auto;
  display: block;
}
@media (max-width: 1200px) {
  .partner-logos {
    gap: 1%; /* 调整每个 Logo 之间的间距 */
  }
  .logo-item {
    width: 30%; /* 每个 Logo 的宽度为 16% */
  }
}
</style>